import { getCurrentSession } from "../../lib/authentication";

export const fetch = params =>
  getCurrentSession().then(({ idToken }) =>
    apigClient
      .ratingsTypeGet(
        params,
        {},
        {
          headers: {
            Authorization: idToken,
          },
        },
      )
      .then(resp => resp.data)
      .catch(e => {
        throw e.data;
      })
  )
